import {gql} from '@apollo/client';
import {CONDITIONS_FRAGMENT} from '../fragments';

export const GET_TOURNAMENT = gql`
  ${CONDITIONS_FRAGMENT}
  query getTournament($tournamentId: ID!) {
    getTournament(tournamentId: $tournamentId) {
      _id
      name
      startDate
      finishDate
      address {
        country
        state
        city
      }
      conditions {
        ...ConditionsFields
      }
      status
      hasFinal
      inscriptions {
        user {
          uid
          fullName
          phoneNumber
          gender
          clubId
          status
          ranking
          address {
            country
            state
            city
          }
        }
        state
      }
      standing
    }
  }
`;

export const GET_TOURNAMENTS = gql`
  ${CONDITIONS_FRAGMENT}
  query getTournaments {
    getTournaments {
      _id
      name
      conditions {
        ...ConditionsFields
      }
      status
      hasFinal
      inscriptions {
        user {
          uid
          fullName
          phoneNumber
          gender
          clubId
          status
          ranking
          email
          document
          address {
            country
            state
            city
          }
        }
        state
      }
    }
  }
`;
